package com.karawek.core.auth.screen

import com.karawek.core.auth.model.AuthMethod
import com.karawek.core.auth.model.AuthenticatedUser
import com.karawek.core.auth.model.OAuthProvider
import com.karawek.core.auth.model.OtpChannel
import com.karawek.core.circuit.Parcelize
import com.slack.circuit.runtime.CircuitUiState
import com.slack.circuit.runtime.screen.PopResult
import com.slack.circuit.runtime.screen.Screen

@Parcelize
data class AuthenticationScreen(
    val success: Screen? = null,
    val cancel: Screen? = null,
) : Screen

@Parcelize
data class AuthenticationResult(
    val status: Status,
    val userInfo: AuthenticatedUser? = null,
) : PopResult {
    enum class Status { Authenticated, Cancelled }
}

data class AuthenticationState(
    val availableMethods: Set<AuthMethod> = emptySet(),
    val canCancel: Boolean = false,
    val isLoading: Boolean = false,
    val otpErrorMessage: String? = null,
    val generalErrorMessage: String? = null,

    val selectedOtpChannel: OtpChannel = OtpChannel.Phone,
    val otpDestination: String = "",

    val eventSink: AuthenticationEventSink = AuthenticationEventSink {},
) : CircuitUiState

fun interface AuthenticationEventSink {
    operator fun invoke(event: AuthenticationEvent)
}

sealed interface AuthenticationEvent {
    data object OnAppear : AuthenticationEvent

    data class SelectOtpChannel(
        val channel: OtpChannel,
    ) : AuthenticationEvent

    data class UpdateOtpDestination(
        val value: String,
    ) : AuthenticationEvent

    data object StartOtp : AuthenticationEvent

    data class StartOAuth(
        val provider: OAuthProvider,
    ) : AuthenticationEvent

    data object StartNativeAuth : AuthenticationEvent

    data object StartPasskey : AuthenticationEvent

    data object Cancel : AuthenticationEvent
    data object DismissError : AuthenticationEvent
}
